export default {
  EMAIL_LOGIN: '/login/email',
  EMAIL_SENT: '/login/email-link-sent',
};
